import state from './AppState';
import getters from './AppGetters';
import mutations from './AppMutations';
import actions from './AppActions';

export default {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
};
